export default __webpack_public_path__ + "static/beach-clean-hero-3362d0772ebde8d8532b6f02ae0ce44d.jpg";